import {
  Directive,
  ElementRef,
  inject,
  input,
  OnDestroy,
  OnInit,
  output,
} from '@angular/core';
import { debounceTime, fromEvent, Subject, takeUntil } from 'rxjs';
import {
  INFINITE_SCROLL_DEBOUNCE_TIME,
  INFINITE_SCROLL_PRELOAD_PERCENTAGE,
  INFINITE_SCROLL_THRESHOLD,
} from '@shared/constants/infinite-scroll.constants';

@Directive({
  selector: '[hmInfiniteScroll]',
  standalone: true,
})
export class InfiniteScrollDirective implements OnInit, OnDestroy {
  scrollThreshold = input<number>(INFINITE_SCROLL_THRESHOLD);
  scrollDebounce = input<number>(INFINITE_SCROLL_DEBOUNCE_TIME);
  preloadPercentage = input<number>(INFINITE_SCROLL_PRELOAD_PERCENTAGE);
  scrollEnd = output<void>();

  private destroy$ = new Subject<void>();

  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  ngOnInit() {
    fromEvent(this.elementRef.nativeElement, 'scroll')
      .pipe(debounceTime(this.scrollDebounce()), takeUntil(this.destroy$))
      .subscribe(() => this.onScroll());
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private onScroll() {
    const element = this.elementRef.nativeElement;
    const scrollPosition = element.scrollTop + element.clientHeight;
    const scrollHeight = element.scrollHeight;
    const triggerPoint = scrollHeight * this.preloadPercentage();

    if (scrollPosition >= triggerPoint) {
      this.scrollEnd.emit();
    }
  }
}
